import React from "react"
import NotesDrawer from "../Notes/Drawer"
import { DRAWER_WIDTH } from "@/utils/constants"
import { setOpenedModals } from "@/graphql/reactiveVars"
import { useReactiveVar } from "@apollo/client/react"
import { without } from "lodash"
import EditReportModal from "../Reports/EditReportModal";
import ViewReportModal from "../Reports/ViewReportModal"
import ReportContextProvider from "@/Contexts/ReportContext/Provider"
import CreateEventModal from "../Events/CreateEventModal"
import CreateTaskModal from "../Tasks/CreateTaskModal"
import CreateNoteModal from "../Notes/CreateNoteModal"
import KickOffContextProvider from "@/Contexts/KickOff/Provider"
import CreateKickoffModal from "@/components/KickOffs/CreateModal"
import CreateProjectModal from "../Projects/CreateProjectModal"
import ProjectContextProvider from "@/Contexts/Project/Provider"

const ControlledModals: React.FC = () => {
  const openedModals = useReactiveVar(setOpenedModals);
  return (
    <React.Fragment>
      <NotesDrawer
        open={openedModals.includes('Note')}
        onClose={() => setOpenedModals(without(openedModals, 'Note'))}
        sx={{
          width: DRAWER_WIDTH,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: DRAWER_WIDTH,
          },
        }}
      />
      {openedModals.includes('CreateEvent') && (
        <CreateEventModal minimized={false} handleClose={() => setOpenedModals(without(openedModals, 'CreateEvent'))} />
      )}
      {openedModals.includes('EditReport') && (
        <EditReportModal minimized={false} handleClose={() => setOpenedModals(without(openedModals, 'EditReport'))} />
      )}
      {openedModals.includes('ViewReport') && (
        <ReportContextProvider>
          <ViewReportModal minimized={false} handleClose={() => setOpenedModals(without(openedModals, 'ViewReport'))} />
        </ReportContextProvider>
      )}
      {openedModals.includes('CreateTask') && (
        <CreateTaskModal minimized={false} handleClose={() => setOpenedModals(without(openedModals, 'CreateTask'))} />
      )}
      {openedModals.includes('CreateNote') && (
        <CreateNoteModal minimized={false} handleClose={() => setOpenedModals(without(openedModals, 'CreateNote'))} />
      )}
      {openedModals.includes('CreateProject') && (
        <ProjectContextProvider>
          <CreateProjectModal minimized={false} handleClose={() => setOpenedModals(without(openedModals, 'CreateProject'))} />
        </ProjectContextProvider>
      )}
      {openedModals.includes('KickOff') && (
        <KickOffContextProvider>
          <CreateKickoffModal
            minimized={false}
            handleClose={() => {
              // const spider = document.getElementById('action-spider')
              // if (spider) {
              //   spider.style.visibility = "visible"
              // }
              setOpenedModals(without(openedModals, 'KickOff'))
            }}
          />
        </KickOffContextProvider>
      )}
    </React.Fragment>
  );
};

export default ControlledModals;
